import sectionPostCss from '../css-snippets/section-post';

const html = ` 
<style>${sectionPostCss}</style>
<div
  class="post-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="post-container container">
    <p class="post-breadcrumb">
      Toy > Family Gift Toys > Kid & Pet Interactive Toys
    </p>
    <div class="post-title">
      <h2>
        <strong
          >Why 10,000+ Parents Are Ditching Screen Time For This Weird Crawling
          Lizard Toy</strong
        >
      </h2>
    </div>
    <div class="post-author-info">
      <div class="post-author-avatar">
        <img
          src="https://cdn.latteprint.com/latte/2025-08-22/1755856692811-79.jpg"
          alt="image"
        />
      </div>
      <div class="post-author-divider"></div>
      <div class="post-author-info-content">
        <h3 class="post-author-name">Elysia F.</h3>
        <p class="post-author-time">12/12/2025</p>
      </div>
    </div>
    <div class="post-summary">
      If your kids lose interest in new toys within minutes... if your pet
      ignores every expensive toy you buy... if you're tired of watching them
      zone out on screens instead of PLAYING—then you're about to discover why
      this isn't just another toy. It's the solution to the "Predictability
      Trap" that's been sabotaging playtime all along.
    </div>
    <div class="post-content">
      <div data-attribute="content" data-text-color="" data-background="">
        <figure class="image image_resized" style="width: 100%">
          <img
            src="https://cdn.skyfastimg.com/images/2025/12/13/image-693ce13b77fbc083a716203f.png?q=80"
          />
        </figure>
        <h2 style="margin: 0 !important"><br /></h2>
        <h2>
          <span
            style="background-color: rgb(255, 255, 255); color: rgb(0, 0, 0)"
          >
            <strong>
              7 Reasons This Electric Lizard Toy Is Becoming Every Household's
              Secret Weapon Against Boredom
            </strong>
          </span>
        </h2>
      </div>
    </div>
  </div>
</div>
`;

export default html;
